import { css } from 'styled-components'

const UIBox = css`
    border-radius: 3px;
    box-shadow: 0 0 2px 1px rgba(120, 120, 120, 0.1);
`

export { UIBox } /* eslint-disable-line import/prefer-default-export */
